import CONFIG from "../config";

let environment = null;

export function setEnvironment(isProd) {
  environment = isProd ? "prod" : "dev";
}

export function getConfig() {
  if (!environment) return {};
  return CONFIG[environment];
}
